import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import { IoDocumentText } from "react-icons/io5";
import { MdInsertPhoto, MdPictureAsPdf } from "react-icons/md";

import { CloseAdminModalIcon, ViewIcon } from "../../../assets";
import {
  agentApprovalTabs,
  EMPTY_STRING,
  preferredContactMethod,
} from "../../../constants";
import RoundedButton from "../../../shared/components/buttons/RoundedButton";
import { adminActions } from "../../../redux/actions/admin.actions";
import { getLabelsByIds } from "../../../shared/utility";
import { countryAction } from "../../../redux/actions";
import { APPROVAL_STATUS, IMAGE_TYPES } from "../../../system";

const AgentApprovalModal = ({
  show,
  closeModal,
  openRejectModal,
  agentId,
  agentDetails,
  getAgentDetails,
  allLanguages,
  getAllLanguages,
  approveAgent,
  allCountries,
}) => {
  const [currentTab, setCurrentTab] = useState(agentApprovalTabs.PERSONAL_INFO);

  const handleChangeTab = (tab) => {
    setCurrentTab(tab);
  };

  useEffect(() => {
    if (show) {
      getAgentDetails(agentId);
      getAllLanguages();
    } else {
      setCurrentTab(agentApprovalTabs.PERSONAL_INFO);
    }

    // eslint-disable-next-line
  }, [show]);

  const getDocumentIcon = (document) => {
    const extension = document.image.split(".").pop().toLowerCase();

    const iconMap = {
      doc: <IoDocumentText size={20} />,
      docx: <IoDocumentText size={20} />,
      pdf: <MdPictureAsPdf size={20} />,
    };

    return iconMap[extension] || <MdInsertPhoto size={20} />;
  };

  return (
    <Modal
      centered
      show={show}
      onHide={closeModal}
      className="subadmin-modal"
      size="lg"
    >
      <Modal.Header className="align-items-center justify-content-between subadmin-modal-header pt-4 ps-4">
        <div className="subadmin-modal-heading">Agent Approval</div>
        <img
          src={CloseAdminModalIcon}
          className="pointer"
          onClick={closeModal}
          alt={EMPTY_STRING}
        />
      </Modal.Header>
      <Modal.Body className="agent-approval-modal-body">
        <div className="agent-tabs d-flex justify-content-around justify-content-sm-center justify-content-md-start gap-3 mt-0">
          <div
            className={`tab text-center pointer ${
              currentTab === agentApprovalTabs.PERSONAL_INFO
                ? "selected-tab"
                : EMPTY_STRING
            }`}
            onClick={() => handleChangeTab(agentApprovalTabs.PERSONAL_INFO)}
          >
            Personal Information
            <div className="trapezoid" />
          </div>
          <div
            className={`tab text-center pointer ${
              currentTab === agentApprovalTabs.COMPANY_INFO
                ? "selected-tab"
                : EMPTY_STRING
            }`}
            onClick={() => handleChangeTab(agentApprovalTabs.COMPANY_INFO)}
          >
            Company Information
            <div className="trapezoid" />
          </div>
        </div>
        <div className="agent-details-container">
          {currentTab === agentApprovalTabs.PERSONAL_INFO ? (
            <>
              <div className="row">
                <div className="col-12 col-lg-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="info-label">First Name:</div>
                    </div>
                    <div className="col-6">
                      <div className="info-value">{agentDetails.firstName}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="info-label">Last Name:</div>
                    </div>
                    <div className="col-6">
                      <div className="info-value">{agentDetails.lastName}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="info-label">Phone Number:</div>
                    </div>
                    <div className="col-6">
                      <div className="info-value">
                        +{agentDetails.phoneNumber}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="info-label">Email Address:</div>
                    </div>
                    <div className="col-6">
                      <div className="info-value">{agentDetails.email}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="info-label">
                        Preferred Contact Method:
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="info-value">
                        {getLabelsByIds(
                          preferredContactMethod,
                          agentDetails.preferredContactMethod,
                          "name"
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="info-label">Languages Spoken:</div>
                    </div>
                    <div className="col-6">
                      <div className="info-value">
                        {getLabelsByIds(
                          allLanguages,
                          agentDetails?.languageSpokenIds,
                          "name"
                        )?.map(
                          (instance, index) =>
                            instance +
                            `${
                              getLabelsByIds(
                                allLanguages,
                                agentDetails?.languageSpokenIds,
                                "name"
                              ).length ===
                              index + 1
                                ? ""
                                : ", "
                            }`
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="agent-info-heading agent-info-sub-heading mt-4">
                Emergency Contact Information
              </div>
              <div className="row">
                <div className="col-12 col-lg-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="info-label">Full Name:</div>
                    </div>
                    <div className="col-6">
                      <div className="info-value">
                        {agentDetails?.emergencyContactInfo?.fullName}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="info-label">Phone Number:</div>
                    </div>
                    <div className="col-6">
                      <div className="info-value">
                        +{agentDetails?.emergencyContactInfo?.phoneNumber}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-12 col-lg-6">
                  <div className="agent-info-heading agent-info-sub-heading">
                    Photo ID
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="photo-ids-container w-100 mt-2">
                        {agentDetails?.images
                          ?.filter(
                            (image) =>
                              image.imageType === IMAGE_TYPES.TYPE_PHOTO_ID
                          )
                          ?.map((img, index) => (
                            <div className="d-flex gap-2 justify-content-between align-items-center mb-2">
                              <div className="d-flex align-items-center gap-2">
                                <MdInsertPhoto size={20} />
                                <div className="img-name">{`photoId${
                                  index + 1
                                }.${
                                  img.image.split(".")[
                                    img.image.split(".").length - 1
                                  ]
                                }`}</div>
                              </div>
                              <a href={img.image} target="_blank">
                                <img src={ViewIcon} alt="" />
                              </a>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="agent-info-heading agent-info-sub-heading">
                    Professional Headshot
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="photo-ids-container w-100 mt-2">
                        {agentDetails?.images
                          ?.filter(
                            (image) =>
                              image.imageType === IMAGE_TYPES.TYPE_HEADSHOT
                          )
                          ?.map((headshot, index) => (
                            <div className="d-flex gap-2 justify-content-between align-items-center mb-2">
                              <div className="d-flex align-items-center gap-2">
                                <MdInsertPhoto size={20} />
                                <div className="img-name">{`image${index + 1}.${
                                  headshot.image.split(".")[
                                    headshot.image.split(".").length - 1
                                  ]
                                }`}</div>
                              </div>
                              <a href={headshot.image} target="_blank">
                                <img src={ViewIcon} alt="" />
                              </a>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="agent-info-heading agent-info-sub-heading">
                    Registration Document
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="photo-ids-container w-100 mt-2">
                        {agentDetails?.images
                          ?.filter(
                            (image) =>
                              image.imageType === IMAGE_TYPES.TYPE_DOCUMENT
                          )
                          ?.map((photoId, index) => (
                            <div className="d-flex gap-2 justify-content-between align-items-center mb-2">
                              <div className="d-flex align-items-center gap-2">
                                {getDocumentIcon(photoId)}
                                <div className="img-name">{`document.${
                                  photoId.image.split(".")[
                                    photoId.image.split(".").length - 1
                                  ]
                                }`}</div>
                              </div>
                              <a href={photoId.image} target="_blank">
                                <img src={ViewIcon} alt="" />
                              </a>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="row">
                <div className="col-12 col-lg-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="info-label">Company/Agency Name:</div>
                    </div>
                    <div className="col-6">
                      <div className="info-value">
                        {agentDetails?.company?.name}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="info-label">Phone Number:</div>
                    </div>
                    <div className="col-6">
                      <div className="info-value">
                        +{agentDetails?.company?.phoneNumber}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="info-label">Licence Number:</div>
                    </div>
                    <div className="col-6">
                      <div className="info-value">
                        {agentDetails?.company?.licenseNumber}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="info-label">Website URL:</div>
                    </div>
                    <div className="col-6">
                      <div className="info-value">
                        {agentDetails?.company?.websiteUrl}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="info-label">Office Address Line 1:</div>
                    </div>
                    <div className="col-6">
                      <div className="info-value">
                        {agentDetails?.company?.addressLine1}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="info-label">Office Address Line 2:</div>
                    </div>
                    <div className="col-6">
                      <div className="info-value">
                        {agentDetails?.company?.addressLine2 ?? "N/A"}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="info-label">Country:</div>
                    </div>
                    <div className="col-6">
                      <div className="info-value">
                        {getLabelsByIds(
                          allCountries,
                          agentDetails?.company?.countryId,
                          "name"
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="info-label">State:</div>
                    </div>
                    <div className="col-6">
                      <div className="info-value">
                        {agentDetails?.company?.state}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="row">
                    <div className="col-6">
                      <div className="info-label">City:</div>
                    </div>
                    <div className="col-6">
                      <div className="info-value">
                        {agentDetails?.company?.city}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="agent-info-heading agent-info-sub-heading mt-4">
                Office Hours
              </div>
              <div className="row">
                <div className="col-12 col-lg-6">
                  {(
                    agentDetails?.company?.officeHours?.filter(
                      (schedule) => schedule.isActive
                    ) ?? []
                  )
                    .slice(0, 4)
                    .map((day, index) => (
                      <div className="row">
                        <div className="col-6">
                          <div className="info-label">{day.name}:</div>
                        </div>
                        <div className="col-6">
                          <div className="info-value">
                            {day.startTime} - {day.endTime}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
                <div className="col-12 col-lg-6">
                  {(
                    agentDetails?.company?.officeHours?.filter(
                      (schedule) => schedule.isActive
                    ) ?? []
                  )
                    .slice(4)
                    .map((day, index) => (
                      <div className="row">
                        <div className="col-6">
                          <div className="info-label">{day.name}:</div>
                        </div>
                        <div className="col-6">
                          <div className="info-value">
                            {day.startTime} - {day.endTime}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </>
          )}
        </div>
        {agentDetails?.approvalStatus !== APPROVAL_STATUS.REJECTED && (
          <div className="agent-approval-buttons-container d-flex justify-content-center gap-3 py-4">
            <RoundedButton onClick={approveAgent}>Approve</RoundedButton>
            <RoundedButton className="reject-button" onClick={openRejectModal}>
              Reject
            </RoundedButton>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  agentDetails: state.adminReducer.agentDetails,
  allLanguages: state.countryReducer.allLanguages,
  allCountries: state.countryReducer.allCountries,
});

const mapDispatchToProps = (dispatch) => ({
  getAgentDetails: (id) => dispatch(adminActions.getAgentDetails(id)),
  getAllLanguages: () => dispatch(countryAction.getAllLanguages()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AgentApprovalModal);
